import { render, staticRenderFns } from "./RowActionMenu.vue?vue&type=template&id=2dcdfeca&scoped=true&"
import script from "./RowActionMenu.vue?vue&type=script&lang=js&"
export * from "./RowActionMenu.vue?vue&type=script&lang=js&"
import style0 from "./RowActionMenu.vue?vue&type=style&index=0&id=2dcdfeca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcdfeca",
  null
  
)

export default component.exports